<template>
  <div class="mensa-order">
    <div class="order-header">La tua scelta del giorno</div>
    <div
      class="order-category"
      v-bind:category="category"
      v-for="category in categories"
      v-bind:key="category.name"
    >
      <div class="title" v-if="getDishesByCategory(category).length">
        <div class="icon-container">
          <img v-bind:src="category.mainIcon" />
        </div>
        <h2>{{category.label}}</h2>
      </div>
      <div
        class="order-dish"
        v-for="dish in getDishesByCategory(category)"
        v-bind:key="dish.id"
      >{{dish.name}}</div>
    </div>
    <div v-if="!order.confirmed" class="button-container">
      <div v-on:tap="confirmOrder()" class="button">Conferma</div>
    </div>
    <div v-if="order.confirmed && !orderJustConfirmed" class="button-container">
      <div v-on:tap="deleteOrder()" class="button">Cancella Prenotazione</div>
    </div>
  </div>
</template>
<script>
import { eventBus } from '../services/EventBus';
export default {
  name: 'mensaOrder',
  data() {
    return {
      orderJustConfirmed: false
    };
  },
  props: ['order', 'categories'],
  computed: {
    filteredCategories() {
      return this.categories.filter(c => this.getDishesByCategory(c).length);
    }
  },
  methods: {
    getDishesByCategory(category) {
      return this.order.dishes.filter(d => d.categoria.name === category.name);
    },
    confirmOrder() {
      this.orderJustConfirmed = true;
      this.order.confirmed = true;
      this.$emit('confirmOrder', this.order);
      eventBus.$emit('showBackButton');
    },
    deleteOrder() {
      this.$emit('orderDeleted', this.order);
      eventBus.$emit('hideBackButton');
    }
  }
};
</script>
<style lang="scss" scoped>
.mensa-order {
  margin: 20px 20px 30px;
  position: relative;
  &::after {
    content: '';
    background-image: url('../assets/images/mensa/card-mensa-bck.png');
    background-position: bottom;
    background-repeat: repeat-x;
    position: absolute;
    width: 100%;
    bottom: -10px;
    left: 0;
    height: 10px;
  }
}
.order-header {
  background-color: #ffffff;
  display: flex;
  align-items: center;
  padding: 25px;
  font-weight: 600;
  font-size: 1.06em;
  letter-spacing: 1px;
  @include shadow-bottom;
  margin: 0 0 20px;
}
.order-category {
  background-color: #ffffff;
  @include dotted-bottom;
  &:nth-last-child(1) {
    &::after {
      content: none;
    }
  }
  &:after {
    width: calc(100% - 30px);
    bottom: 0;
    left: 14px;
  }
}

.title {
  display: flex;
  align-items: center;
  padding: 24px 15px;
  h2 {
    font-size: 1.06em;
    font-weight: 600;
    letter-spacing: 1px;
    margin: 0;
  }

  .icon-container {
    margin-right: 10px;
  }
}
.order-dish {
  padding: 0 15px 20px;
  font-size: 0.95em;
  letter-spacing: 0.95px;

  &:nth-last-child(1) {
    padding-bottom: 34px;
  }
}
.button-container {
  background-color: #ffffff;
  padding: 30px 15px 30px;
}
.button {
  background-color: #a31313;
  color: #ffffff;
  text-align: center;
  padding: 20px 0;
  border-radius: 5px;
}
</style>
